// Import all directives
import {EmbedlyDirective} from './directives/embedly.directive';

// Export all directives
export * from './directives/embedly.directive';

// Export convenience property
export const DIRECTIVES: any[] = [
  EmbedlyDirective
];



/** WEBPACK FOOTER **
 ** ./~/tslint-loader?emitErrors=false&failOnHint=false!./src/directives.ts
 **/